// extracted by mini-css-extract-plugin
export default {"modal-actions":"AllSet--modal-actions--txtJL","modalActions":"AllSet--modal-actions--txtJL"};